import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faArrowRight } from "@fortawesome/free-solid-svg-icons";

export default function ProjectBrief({ answers, onContinue }) {
  const { projectType, projectGoals, industryPreference, servicePreferences, budgetRange } = answers;

  const downloadBrief = () => {
    const content = `
PROJECT BRIEF
---------------------------

PROJECT SUMMARY:
${projectType}

GOALS:
${projectGoals}

INDUSTRY:
${industryPreference || "Not specified"}

AI SERVICES REQUIRED:
${servicePreferences.length > 0 ? servicePreferences.join(", ") : "Not specified"}

BUDGET RANGE:
${budgetRange || "Not specified"}

---------------------------
Generated via AI Agency Directory.
`;

    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Project_Brief.txt";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="mt-10 bg-white rounded-2xl shadow-lg p-8 max-w-3xl mx-auto">
      <h2 className="text-3xl font-bold text-secondary mb-4">
        Your Project Brief
      </h2>
      <p className="text-gray-600 mb-8">
        Review your automatically generated project overview. You can download it or continue to matched agencies.
      </p>

      <div className="space-y-8 text-gray-800">
        <div>
          <h3 className="font-bold text-primary text-xl mb-2">Project Summary</h3>
          <p className="whitespace-pre-line">{projectType || "—"}</p>
        </div>

        <div>
          <h3 className="font-bold text-primary text-xl mb-2">Goals</h3>
          <p className="whitespace-pre-line">{projectGoals || "—"}</p>
        </div>

        <div>
          <h3 className="font-bold text-primary text-xl mb-2">Industry</h3>
          <p>{industryPreference || "Not specified"}</p>
        </div>

        <div>
          <h3 className="font-bold text-primary text-xl mb-2">AI Services Needed</h3>
          <p>
            {servicePreferences && servicePreferences.length > 0
              ? servicePreferences.join(", ")
              : "Not specified"}
          </p>
        </div>

        <div>
          <h3 className="font-bold text-primary text-xl mb-2">Budget Range</h3>
          <p>{budgetRange || "Not specified"}</p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-center mt-10 gap-4">
        <button
          onClick={downloadBrief}
          className="inline-flex items-center px-6 py-3 bg-primary text-white rounded-full font-semibold hover:bg-primary/90 shadow-md"
        >
          Download Brief
          <FontAwesomeIcon icon={faDownload} className="ml-2" />
        </button>

        <button
          onClick={onContinue}
          className="inline-flex items-center px-8 py-3 bg-secondary text-white rounded-full font-bold text-lg hover:bg-secondary/90 shadow-md"
        >
          Continue to Matched Agencies
          <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
        </button>
      </div>
    </div>
  );
}
